import { apiFetchGeneric } from 'utils'
import { huskyTalesAPIBase } from 'config'

export function getFacultyNewsStories (netid) {
  const endpoint = `/storysearch/${netid}`
  return apiFetchGeneric(huskyTalesAPIBase, endpoint)
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/huskytales.js